'use client';

import { useCallback, useRef } from 'react';

import { useEmailConfirm } from '~features/emailConfirm/hooks/useEmailConfirm';
import { useEmailConfirmationWallLocation } from '~features/emailConfirm/hooks/useEmailConfirmationWallLocation';

export const useEmailConfirmPerformer = () => {
	const doneRef = useRef(false);
	const { saveLocation } = useEmailConfirmationWallLocation();
	const { required, isSuccess } = useEmailConfirm();
	const perform = useCallback(() => {
		if (doneRef.current) {
			return;
		}

		doneRef.current = true;

		if (required) {
			saveLocation(window.location.href);
		}
	}, [required, saveLocation]);

	return isSuccess ? perform : null;
};
